// extracted by mini-css-extract-plugin
export var cxTalksVid = "s-module--cxTalksVid--436f0";
export var onlyMobile = "s-module--onlyMobile--ff207";
export var section = "s-module--section--4bb54";
export var sectionBgBone = "s-module--sectionBgBone--89790";
export var sectionBgCXPowerfulAI = "s-module--sectionBgCXPowerfulAI--2f3a3";
export var sectionBgCXPowerfulAI2 = "s-module--sectionBgCXPowerfulAI2--1447b";
export var sectionBgCxTalkTravelFiresidesMain = "s-module--sectionBgCxTalkTravelFiresidesMain--883f0";
export var sectionBgEcommerce = "s-module--sectionBgEcommerce--a455b";
export var sectionBgEcommerceMeetup = "s-module--sectionBgEcommerceMeetup--60b38";
export var sectionBgFintech = "s-module--sectionBgFintech--e01c8";
export var sectionBgFintechMeetup = "s-module--sectionBgFintechMeetup--3365d";
export var sectionBgGamingExp = "s-module--sectionBgGamingExp--07eea";
export var sectionBgGamingMeetup = "s-module--sectionBgGamingMeetup--68378";
export var sectionBgGamingMeetupLanding = "s-module--sectionBgGamingMeetupLanding--33883";
export var sectionBgGrey = "s-module--sectionBgGrey--01082";
export var sectionBgLightGrey = "s-module--sectionBgLightGrey--2e7be";
export var sectionBgOrangeFintech = "s-module--sectionBgOrangeFintech--1f563";
export var sectionBgOrangeHome = "s-module--sectionBgOrangeHome--7ac1c";
export var sectionBgTechMeetup = "s-module--sectionBgTechMeetup--bb434";
export var sectionBgTechRegister = "s-module--sectionBgTechRegister--d25ff";
export var sectionBgTestimonial = "s-module--sectionBgTestimonial--69210";
export var sectionBgTravel = "s-module--sectionBgTravel--4ca9b";
export var sectionBgTravelBg = "s-module--sectionBgTravelBg--02be5";
export var sectionBgWhite = "s-module--sectionBgWhite--e2d0d";
export var sectionBgWorkLifeBlock = "s-module--sectionBgWorkLifeBlock--458b0";
export var sectionBgYellow = "s-module--sectionBgYellow--1190d";